import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { TaskForm } from "./task-form";
import { Plus } from "lucide-react";

export function TaskFormDialog() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="default" size="sm" className="flex items-center gap-2">
          <Plus className="w-4 h-4" />
          New Item
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto bg-gray-900 border-gray-800 p-0">
        <DialogHeader className="p-6 pb-4 border-b border-gray-800">
          <DialogTitle className="text-xl font-semibold text-gray-100">Create New Task</DialogTitle>
        </DialogHeader>
        <div className="p-6">
          <TaskForm />
        </div>
      </DialogContent>
    </Dialog>
  );
}
